import { render, staticRenderFns } from "./About.vue?vue&type=template&id=ef1a9b78&scoped=true&lang=pug&"
import script from "./About.vue?vue&type=script&lang=js&"
export * from "./About.vue?vue&type=script&lang=js&"
import style0 from "./About.vue?vue&type=style&index=0&id=ef1a9b78&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef1a9b78",
  null
  
)

export default component.exports